import React, { useState } from 'react';
import { Form } from 'react-bootstrap';

import HeaderLogin from '../../components/HeaderLogin';

import logo from '../../assets/images/logo3.svg';
import arrow from '../../assets/images/arrowLeft.svg';

import api from '../../services/api';

import './styles.css';

export const RecoveryPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    setLoading(true);

    const form = new FormData();
    
    form.append('email', email);

    api.post('/auth/reset-senha', form).then(res => {
      alert(`Um e-mail de recuperação de senha foi enviado para ${res.data.email}`);
      setEmail('');
      setLoading(false);
    })
    .catch(err => {
      alert(err.response.data.errors.email[0]);
      setLoading(false);
    });
  }

  return (
    <>
      {/* <HeaderLogin /> */}
      <div id="content-login" className="d-flex">        
        <div className="box-login">
          <img src={logo} className="logo" alt="Cury" onClick={() => window.location.href='/'} />
          <h3>Recuperar senha</h3>
          <Form>
            <Form.Group>
              <Form.Label>E-mail</Form.Label>
              <Form.Control type="email" placeholder="Informe seu e-mail" value={email} onChange={(e) => setEmail(e.target.value)} />
            </Form.Group>
            <button onClick={() => handleSubmit()} disabled={loading}>{loading ? 'Carregando...' : `Solicitar nova senha`}</button>
          </Form>
          <a id="back-login" href="/login"><img id="arrow-back" src={arrow} alt="Icon" /> Voltar</a>
        </div>
        <div className="bg-login"></div>
      </div>
    </>
  );
  
}

export default RecoveryPassword;